// Shared Chakra style prop objects for the reservations view. Colors that must
// adapt to color mode are applied in the components via useColorModeValue.

/** Table header cell props (Chakra Th). */
export const HEAD_CELL = {
  borderColor: "transparent",
  fontSize: "10px",
  fontWeight: "700",
  letterSpacing: "0.5px",
  py: "12px",
};

/** Table body cell props (Chakra Td). */
export const BODY_CELL = {
  borderColor: "transparent",
  fontSize: "sm",
  py: "10px",
};

/** Clickable row props (Chakra Tr). */
export const ROW = {
  cursor: "pointer",
  transition: "background 120ms ease",
};

/** Key/value row props inside the detail drawer (Chakra Flex). */
export const KV_ROW = {
  justify: "space-between",
  gap: "16px",
  py: "6px",
};
